import { Zap, Heart, Target, Smile } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Reveal, SectionTitle } from "@/components/site/Reveal";
import { ProcessSteps, PaymentCard } from "@/components/site/ProcessSteps";
import { CtaButton } from "@/components/site/Header";
import { Squiggle, Star, Scribble } from "@/components/site/Doodles";

const VALUES = [
  { Icon: Zap, title: "طاقة في كل فريم", text: "بنحب الحركة السريعة والأفكار اللي بتصحّي العين." },
  { Icon: Target, title: "رسالة واضحة", text: "الإعلان الحلو هو اللي بيوصّل أهم نقطة عندك من غير لف ودوران." },
  { Icon: Heart, title: "شغل بحب", text: "كل مشروع بنتعامل معاه كأنه براندنا احنا." },
  { Icon: Smile, title: "تعامل سهل", text: "خطوات واضحة من أول رسالة لحد ما تستلم الفيديو." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo title="مين احنا" description="تعرّف على خرابيش موشن، استوديو موشن جرافيك مصري بيحوّل أفكار البراندات لإعلانات متحركة." />
      <section className="km-grid-bg relative overflow-hidden">
        <Star className="km-float absolute left-[10%] top-16 h-12 w-12" />
        <Scribble className="km-wiggle absolute bottom-10 left-[30%] hidden h-24 w-24 md:block" />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 md:py-28 lg:px-8">
          <Reveal>
            <p className="font-head mb-4 text-[var(--km-cyan)]">مين احنا</p>
            <h1 className="font-display max-w-4xl text-5xl leading-tight text-white sm:text-6xl lg:text-7xl">
              احنا ناس بتخربش..
              <span className="relative block text-[var(--km-pink)]">
                بس خرابيشنا بتبيع
                <Squiggle className="absolute -bottom-4 right-0 h-6 w-64" color="#E9D8FF" />
              </span>
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-14 grid gap-8 text-lg leading-loose text-purple-100/90 md:grid-cols-2">
              <p>خرابيش موشن استوديو موشن جرافيك متخصص في الإعلانات المتحركة. فكرتنا بسيطة: كل براند عنده حكاية، واحنا شغلتنا نحكيها بالحركة والألوان والإيقاع بطريقة تخلي الناس توقف السكرول وتتفرج.</p>
              <p>بنبدأ معاك من اللوجو والبريف وأولويات الإعلان، ونطلع بفيديو معمول على مقاس براندك، بألوانك وبصوتك، وجاهز يتنشر على السوشيال ميديا.</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <SectionTitle kicker="بنآمن بإيه" title="روح الاستوديو" />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {VALUES.map(({ Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 0.07}>
              <div className={`h-full rounded-3xl border border-purple-500/25 bg-[var(--km-card)] p-6 transition-transform duration-300 hover:-translate-y-2 ${i % 2 ? "lg:translate-y-8" : ""}`} data-testid={`about-value-${i}`}>
                <Icon className="mb-4 h-10 w-10 text-[var(--km-pink)]" />
                <h3 className="font-head text-xl font-bold text-white">{title}</h3>
                <p className="mt-2 text-purple-200/85">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <SectionTitle kicker="طريقة الشغل" title="من أول رسالة لحد الفيديو النهائي" />
        <ProcessSteps />
        <PaymentCard />
        <div className="mt-12"><CtaButton className="px-8 py-4 text-lg" testId="about-create-ad-btn" /></div>
      </section>
    </div>
  );
}
